import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 5v14l12 -7z","key":"svg-0"}],["path",{"d":"M20 5l0 14","key":"svg-1"}]]

const IconPlayerSkipForward = createReactComponent('outline', 'player-skip-forward', 'PlayerSkipForward', __iconNode);

export default IconPlayerSkipForward;